// extracted by mini-css-extract-plugin
module.exports = {"freeShippingContainer":"az_xgc","freeDelivery":"az_ygc","freeShippingContainerBorder":"az_zgc"};